var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import AssemblyInformationRow from "../../components/projecttablerows/assemblyinformationrow.vue";
import CollapsingElement from "../../components/projecttablerows/collapsingelement.vue";
import HoverThumbnail from "../../components/hoverthumbnail.vue";
import { CheckedState, articleName, } from "../utilities/projecttable";
let AssemblyTableRow = class AssemblyTableRow extends Vue {
    onClick() { }
    onCheck() { }
    isThumbnailColumn(columnName) { return columnName === "thumbnailAssembly"; }
    isNameColumn(columnName) { return columnName === "articleName"; }
    isCollapsedStateColumn(columnName) { return columnName === "collapsedState"; }
    isCheckBoxColumn(columnName) { return columnName === "checkbox"; }
    cssType(columnName) {
        if (this.isThumbnailColumn(columnName)) {
            return "img";
        }
        else if (this.isNameColumn(columnName)) {
            return "name";
        }
        else {
            return "";
        }
    }
    cssClass(columnName) {
        if (this.isCollapsedStateColumn(columnName)) {
            return "fas fa-chevron-" + (this.isOpened ? "down" : "right");
        }
        else {
            return "";
        }
    }
    get selectionFull() { return this.displayInfo.checkedState === CheckedState.all; }
    get selectionPartial() { return this.displayInfo.checkedState === CheckedState.partial; }
    get articleName() {
        return articleName(this.displayInfo, this.searchText);
    }
};
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "animate", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "assembly", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "columns", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "displayInfo", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "isOpened", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "Renderer3d", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "rowIndex", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "searchText", void 0);
__decorate([
    Prop({ required: true })
], AssemblyTableRow.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], AssemblyTableRow.prototype, "networkBroker", void 0);
__decorate([
    Emit("click")
], AssemblyTableRow.prototype, "onClick", null);
__decorate([
    Emit("assembly-checked")
], AssemblyTableRow.prototype, "onCheck", null);
AssemblyTableRow = __decorate([
    Component({
        components: {
            AssemblyInformationRow,
            CollapsingElement,
            HoverThumbnail,
        },
        name: "AssemblyTableRow",
    })
], AssemblyTableRow);
export default AssemblyTableRow;
